import { render } from "./MinimalLayout.vue?vue&type=template&id=8029ed8c"
import script from "./MinimalLayout.vue?vue&type=script&lang=js"
export * from "./MinimalLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__